import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API || '/api',
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const hasAuthZ   = !!config.headers.Authorization;
  const hasAutoTok = !!config.headers.authtoken;

  const lsToken = localStorage.getItem('token');
  if (lsToken) {
    if (!hasAuthZ)   config.headers.Authorization = `Bearer ${lsToken}`;
    if (!hasAutoTok) config.headers.authtoken    = lsToken;
  }
  return config;
});

export default api;
